import React from 'react'
import { Link } from 'gatsby'
import styles from './Footer.module.css'
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { StaticImage } from 'gatsby-plugin-image';

export default function Footer() {
    return (
        <div className={styles.container}>
            <div className={styles.layout}> 
                <div className={styles.wrapper}>
                    <ul className={styles.menu}>
                        <li>
                            <AnchorLink to="/#top">Нүүр</AnchorLink>
                        </li>
                        <li>
                            <Link to="/about">Миний тухай</Link>
                        </li>
                        <li>
                            <Link to="/license">Тусгай зөвшөөрөл</Link>
                        </li>
                        <li>
                            <Link to="/legal">Хууль, журам</Link>
                        </li>
                        <li>
                            <Link to="/services/energyaudit">Үйлчилгээ</Link>
                            <ul className={styles.sublist}>
                                <li>
                                    <Link to="/services/energyaudit">
                                        Эрчим хүчний аудит
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/services/energyaudit">
                                        Эрчим хүчний аудит
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/services/energyaudit">
                                        Эрчим хүчний аудит
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <Link to="/works">Хэрэгжүүлсэн төслүүд</Link>
                        </li>

                        <li>
                            <Link to="/photoalbum">Зургийн цомог</Link>
                        </li>
                        <li>
                            <Link to="/advisory">Зөвлөмж</Link>
                        </li>
                        <li>
                            <AnchorLink to="/#contact">Холбоо барих</AnchorLink>
                        </li>
                    </ul>
                    <div className={styles.right}>
                        <ul>

                            <h3>Холбоо барих: </h3>
                            <li>
                                88113855
                            </li>
                            <li>danzanshadav@gmail.com</li>
                            
                            <ul className={styles.social_icons}>
                            
                                <li>
                                    <a href='https://www.facebook.com/%D0%AD%D1%80%D1%87%D0%B8%D0%BC-%D1%85%D2%AF%D1%87%D0%BD%D0%B8%D0%B9-%D0%B0%D1%83%D0%B4%D0%B8%D1%82-749204298591887' target="_blank" rel="noreferrer"> 
                                        <StaticImage src="../../images/facebook.svg" alt="facebook icon" width={25} height={25}/>
                                    </a>
                                </li>
                                <li>
                                    <a href='https://www.facebook.com/%D0%AD%D1%80%D1%87%D0%B8%D0%BC-%D1%85%D2%AF%D1%87%D0%BD%D0%B8%D0%B9-%D0%B0%D1%83%D0%B4%D0%B8%D1%82-749204298591887' target="_blank" rel="noreferrer"> 
                                        <StaticImage src="../../images/instagram.svg" alt="instagram icon" width={25} height={25} />
                                    </a>
                                </li>
                                <li>
                                    <a href='https://www.linkedin.com/in/baasansren-d-b8a511149/?fbclid=IwAR0D8q3KhmSRMcF8r4hbsEprDsWpkp9MjyV65co0adAFrB8eOQNCrGtgSVQ' target="_blank" rel="noreferrer">
                                        <StaticImage src="../../images/linkedin.svg" alt="linkedin icon" width={25} height={25}/>
                                    </a>
                                </li>
                            </ul>
                        </ul>
                        <p> Copyright (c) 2021 Bilguun. All rights reserved.</p>  
                    </div>
                </div>
            </div>
        </div>
    )
}
